import styled from 'styled-components';

export const StyledChevronDownIcon = styled.svg`
    background: none;
    border: none;
    cursor: pointer;
`;
